import React from 'react';
export function Footer() {
  return <footer className="py-6 px-4 bg-brand-graphite text-center text-brand-cream/60 text-xs" data-id="element-73">
      <div className="max-w-3xl mx-auto space-y-3" data-id="element-74">
        <p className="leading-snug max-w-2xl mx-auto font-medium" data-id="element-75">
          © {new Date().getFullYear()} Yoga Ready™ — All Rights Reserved. The
          content of this page is for informational and educational purposes. It
          does not replace certified professional training. Consult a health
          professional before starting any physical activity.
        </p>
        <div className="flex justify-center gap-3 font-bold tracking-wide uppercase" data-id="element-76">
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-77">
            Terms & Conditions
          </a>
          <span data-id="element-78">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-79">
            Privacy Policy
          </a>
          <span data-id="element-80">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-81">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}